// extracted by mini-css-extract-plugin
export default {"root":"ExcelDownload_root__UXtx4"};